/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Flowdefect1Inputs */



/**
* | output |
* | --- |
* | "Flow sensor fault" |
*
* @param {Ahu_History_Key_Flowdefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_flowdefect1 = /** @type {((inputs?: Ahu_History_Key_Flowdefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Flowdefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Flow sensor fault")
	return /** @type {LocalizedString} */ ("Défaut sonde de débit")
});
export { ahu_history_key_flowdefect1 as "ahu_history_key_flowDefect" }